<template>
<div>
    <popupLayout>
      <button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.showStayStateControl(false);">×</button>
      <header class="text-center">
        <h3>查詢住宿申請</h3>
      </header>
      <div class="bootbox-body">
        <div class="row form-group mb-lg">

          <div class="col-md-12">
            <label class="col-md-4">身分證字號:</label>
            <div class="col-md-8">
              <input type="text" v-model="idno" class="form-control"/>
            </div>

          </div>
          <div class="col-md-12">
            <h4>{{resultState}}</h4>
          </div>
        </div>
        <div class="row">
          <div class="col-md-offset-4 col-md-4">
            <div class=" col-md-offset-3 col-md-6">
              <a class="btn btn-danger btn-block" @click="sreachStayState">送出</a>
            </div>
          </div>
        </div>
      </div>
    </popupLayout>
    <popupStayGiveup v-if="isShowStayGiveup" :msg="msg" :id="id" :isQuit="isQuit"/>
  </div>
</template>
<script>
import popupLayout from './popupLayout';
import popupStayGiveup from './stayGiveup';
export default {
	components:{
		popupLayout,
    popupStayGiveup
	},
	data(){
		return {
			idno:"",
			resultState:"",
      id:"",
      isShowStayGiveup:false,
      msg:"",
      isQuit:false
		}
	},
	methods:{
		sreachStayState(){
			if(!this.idno){
				bootbox.alert("請輸入身分證字號");
			}else{
				const api = "/api/Room/stayApplyState/"+this.idno;
				this.$axios.post(api).then(resp=>{
					if(resp.data.status == "warn"){
						let _this = this;
						const da = resp.data.data;
						bootbox.confirm(resp.data.msg, function(result){
							if(result){
								_this.$parent.showStayStateControl(false);
								_this.gotoView('stay.apply.edit', {dormitoryType: da.dormitoryType, id: da.id, idno: da.idno, account: da.account});
							}
						});
					}else{
            if(resp.data.status == "success" && resp.data.data.writeOffStatus != 'Y' && !!resp.data.data.bankBarcode1) {
              this.msg = resp.data.msg;
              this.id = resp.data.data.id;
              this.isQuit = !!resp.data.data.quitProve;
              this.isShowStayGiveup = true;
            } else {
              bootbox.alert(resp.data.msg);
            }
					}
				});
			}
		},
    setShowStayGiveup(show) {
      this.isShowStayGiveup = show;
    },
	}
}
</script>
